import React from "react";
import { Link } from "react-router-dom";
import { Leaf, Facebook, Twitter, Instagram, Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-primary text-primary-foreground mt-20" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1">
            <div className="mb-4">
              <div className="inline-block bg-white rounded-lg px-3 py-2 shadow-sm">
                <img src="/logo.png" alt="OrgShop" className="h-12 w-auto" />
              </div>
            </div>
            <p className="text-primary-foreground/80 text-sm">
              Your trusted marketplace for organic and sustainable products.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/products" className="text-primary-foreground/80 hover:text-accent transition-colors">
                  All Products
                </Link>
              </li>
              <li>
                <Link to="/cart" className="text-primary-foreground/80 hover:text-accent transition-colors">
                  Shopping Cart
                </Link>
              </li>
              <li>
                <Link to="/dashboard" className="text-primary-foreground/80 hover:text-accent transition-colors">
                  My Account
                </Link>
              </li>
            </ul>
          </div>

          {/* For Vendors */}
          <div>
            <h3 className="font-heading text-lg font-semibold mb-4">For Vendors</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/vendor" className="text-primary-foreground/80 hover:text-accent transition-colors">
                  Vendor Dashboard
                </Link>
              </li>
              <li>
                <a href="#" className="text-primary-foreground/80 hover:text-accent transition-colors">
                  Become a Seller
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-heading text-lg font-semibold mb-4">Connect</h3>
            <div className="flex space-x-4 mb-4">
              <a href="#" className="text-primary-foreground/80 hover:text-accent transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-primary-foreground/80 hover:text-accent transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="text-primary-foreground/80 hover:text-accent transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
            <a href="mailto:orgshopin@gmail.com" className="text-primary-foreground/80 hover:text-accent transition-colors flex items-center space-x-2">
              <Mail className="w-4 h-4" />
              <span>orgshopin@gmail.com</span>
            </a>
            <a href="tel:+919884436893" className="text-primary-foreground/80 hover:text-accent transition-colors flex items-center space-x-2 mt-2" data-testid="footer-phone">
              <Phone className="w-4 h-4" />
              <span>+91 98844 36894</span>
            </a>
            <p className="text-primary-foreground/80 text-sm mt-3 flex items-start space-x-2" data-testid="footer-address">
              <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
              <span>3M, Palm Avenue, Sankarapuram 5th Street, Sithalapakkam, Chennai - 600131</span>
            </p>
          </div>
        </div>

        <div className="border-t border-primary-foreground/20 mt-8 pt-8">
          <ul className="flex flex-wrap justify-center gap-x-6 gap-y-3 mb-6 text-sm" data-testid="footer-legal-links">
            <li>
              <Link to="/privacy-policy" className="text-primary-foreground/80 hover:text-accent transition-colors" data-testid="footer-privacy-link">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/terms-and-conditions" className="text-primary-foreground/80 hover:text-accent transition-colors" data-testid="footer-terms-link">
                Terms &amp; Conditions
              </Link>
            </li>
            <li>
              <Link to="/shipping-policy" className="text-primary-foreground/80 hover:text-accent transition-colors" data-testid="footer-shipping-link">
                Shipping Policy
              </Link>
            </li>
            <li>
              <Link to="/refund-policy" className="text-primary-foreground/80 hover:text-accent transition-colors" data-testid="footer-refund-link">
                Return &amp; Refund Policy
              </Link>
            </li>
          </ul>
          <p className="text-primary-foreground/60 text-sm text-center">
            © 2026 OrgShop. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
